import './fb_messenger_user_id';
import './fb_user_profile_factory';



// WEBPACK FOOTER //
// ./factories/customer_profile/index.js